// Port of api/fuel/app/classes/filter/users.php
import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'

var Users = Filter.extend({
	filter_type: F.TYPE_USERS,
	cache_type: F.CACHE_USERS,
	result_type: F.RESULT_USER,
	pseudo_type: F.PSEUDO_USER,
	json_package: 'users',
	package_types: [F.PACKAGE_USER]
})

export default Users
